import actions from '../../actionTypes';

export default (url) => {
  return {
    type: actions.CHECKED_SSO,
    url: url
  };
};


// WEBPACK FOOTER //
// ./src/reducers/auth/actions/checkedSSO.js